import { pgTable, uuid, text, integer, timestamp } from "drizzle-orm/pg-core";

export const priceLists = pgTable("price_lists", {
  id: uuid("id").primaryKey().defaultRandom(),
  code: text("code").notNull().unique(),
  name: text("name").notNull(),
  position: integer("position").notNull().default(0),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type PriceList = typeof priceLists.$inferSelect;
export type NewPriceList = typeof priceLists.$inferInsert;

export const PRICE_LIST_CODES = ["base", "special_a", "special_b"] as const;
export type PriceListCode = (typeof PRICE_LIST_CODES)[number];
